import localForage from 'localforage'
import type { AppState } from './types/index'

const localStorageKey = 'appState'

export def persistData data\AppState
	await localForage.setItem localStorageKey, JSON.stringify(data)

export def loadData\Promise<AppState>
	const dataString = await localForage.getItem localStorageKey
	if dataString
		try
			JSON.parse(dataString)
		catch
			return null
	else
		return null
		
export def clearData
	await localForage.removeItem(localStorageKey)
